import React, { useEffect, useState } from 'react';
import { View, Text, Image, StyleSheet } from 'react-native';
import {
  getBeeBot,
  getBeeBotByDifficulty,
  getBeeBotDifficulty,
  TStage,
} from '../../../utils/journeysUtils';
import BeeModalImage from '../../../resources/images/beeModal.png';
import { isMobile } from '@mightybyte/rnw.utils.device-info';
import ButtonGeneral from '../../helperComponents/ButtonGeneral';
import { ApolloError } from '@apollo/client';
import { useSignedInContext } from '../../../context/SignedInContext';
import { getErrorText } from '../../../utils/errors';
import getUserName from '../../../utils/userUtils';
import { GameMode } from '../GameScreen';
import {
  EventTypeGameEventType,
  GameStatus,
  useGameEventSubscription,
} from '../PlayOnline/useGameEventSubscription.gql';
import { AIDifficultyLevel, useJoinAIGameMutation } from '../PlayWithAI/useJoinAiGameMutation.gql';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { GAME_TYPES_TYPE } from '../../../constants/constants';

type TJourneyModalProps = {
  stage: TStage;
  onClose: () => void;
  onProceed: () => void;
  gameType: GAME_TYPES_TYPE;
  navigation: any;
  route: any;
  journeyId: string;
};

export default function JourneyModal(props: TJourneyModalProps) {
  const { stage, onProceed, gameType, navigation, route, journeyId } = props;

  const [gameDifficultyLevel, setGameDifficultyLevel] = useState(
    getBeeBotDifficulty(stage?.id) || AIDifficultyLevel.EASY,
  );

  const { user } = useSignedInContext();

  const name = getUserName(user);

  const [joinGame, { loading, error }] = useJoinAIGameMutation({
    variables: {
      userName: name,
      difficultyLevel: gameDifficultyLevel,
      aiName: `${getBeeBotByDifficulty(gameDifficultyLevel)}'s bot`,
      gameType: gameType,
    },
  });

  const { data: gameEventSubscription } = useGameEventSubscription({
    onSubscriptionComplete: () => console.log('PlayWithAI completed!'),
  });

  useEffect(() => {
    if (
      gameEventSubscription?.gameEvent.eventType === EventTypeGameEventType.ON_GAME_START &&
      gameEventSubscription.gameEvent.game.status !== GameStatus.FINISHED
    ) {
      navigation.replace('Game', {
        mode: GameMode.PRACTICE,
        difficulty: gameDifficultyLevel,
        journey: true,
        gameType: gameType,
        stageId: stage.id,
        journeyId: journeyId,
        game: gameEventSubscription.gameEvent.game,
      });
      //close window

      onProceed();
    }
    if (
      gameEventSubscription?.gameEvent &&
      gameEventSubscription.gameEvent.game.status === GameStatus.FINISHED
    ) {
      console.warn('finished game ignored!');
    }
  }, [gameDifficultyLevel, gameEventSubscription?.gameEvent, navigation]);

  const handleJoinGameError = (err: ApolloError) => {
    setHasError({ popup: true, visible: true, text: getErrorText(err) });
  };

  const [hasError, setHasError] = useState({
    visible: false,
    popup: false,
    text: '',
  });

  const handleJoinGame = () => {
    AsyncStorage.setItem('playing-name', name);
    joinGame().catch(err => {
      handleJoinGameError(err);
    });
  };

  const handlePress = () => {
    handleJoinGame();
    // onProceed();
  };

  const subtitle = `Build your skills by battling \n Boss Bee-${getBeeBot(stage?.id)}’s bots!`;

  const description = `Win your practice rounds to unlock the final challenge—defeating Boss Bee-${getBeeBot(
    stage?.id,
  )} to complete the level and earn your badge.`;

  const buttonText = isMobile ? 'Done' : 'Practice vs Bee-Bots';
  return (
    <View style={[styles.card]}>
      <View style={[styles.content, { marginTop: isMobile ? 33 : 26 }]}>
        <Image
          source={BeeModalImage}
          style={[styles.image, { height: isMobile ? 128 : 152, width: isMobile ? 78 : 93 }]}
          resizeMode="contain"
        />
        <Text style={[styles.subtitle, { fontSize: isMobile ? 18 : 24 }]}>{subtitle}</Text>
        <Text style={[styles.description, { fontSize: isMobile ? 14 : 16 }]}>{description}</Text>
      </View>

      <View style={[styles.buttonContainer, { height: isMobile ? 80 : 102 }]}>
        <ButtonGeneral
          onPress={handlePress}
          title={buttonText}
          height={48}
          width={isMobile ? 146 : 411}
          fontSize={isMobile ? 14 : 16}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    overflow: 'hidden',
    flexDirection: 'column',
    height: '100%',
  },

  content: {
    alignItems: 'center',
    paddingHorizontal: 60,
    paddingTop: 30,
    flex: 1,
  },
  image: {
    marginBottom: 12,
  },
  subtitle: {
    fontFamily: 'Secular One',
    fontWeight: '400',
    textAlign: 'center',
    marginBottom: 8,
    color: '#000000',
  },
  description: {
    fontFamily: 'Secular One',
    color: '#453B3B',
    textAlign: 'center',
    fontWeight: '700',
  },
  buttonContainer: {
    justifyContent: 'center',
    backgroundColor: '#FEDD88',
    alignItems: 'center',
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
  },

  button: {
    paddingVertical: 12,
    alignItems: 'center',
  },
  buttonText: {
    color: '#fff',
    fontWeight: '600',
    fontSize: 16,
  },
});
